module.exports = __webpack_public_path__ + "static/img/female4.7105791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/comment/female4.png
// module id = wxcj
// module chunks = 1